import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { Person } from '../../../shared/models/people/people/person.model';
import { Observable } from 'rxjs';
import { Tag } from '../../../shared/models/common/tag.model';

@Injectable({
    providedIn: 'root'
})
export class PeopleService extends BaseService<Person> {
    private baseUrl = '/api/people';

    getTags(): Observable<Tag[]> {
        return this.http.get<Tag[]>(`${this.baseUrl}/tags`);
    }
}
